var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcFolderClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66659 2.33325C1.93021 2.33325 1.33325 2.93021 1.33325 3.66659V12.3333C1.33325 13.0696 1.93021 13.6666 2.66659 13.6666H13.3333C14.0696 13.6666 14.6666 13.0696 14.6666 12.3333V5.66659C14.6666 4.93021 14.0696 4.33325 13.3333 4.33325H8.66659L7.80825 2.95992C7.5646 2.57008 7.13731 2.33325 6.67759 2.33325H2.66659Z",
    fill: "#58606E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFolderClose);
export default __webpack_public_path__ + "static/media/ic_folder_close.14c3c03a.svg";
export { ForwardRef as ReactComponent };